import { useContext } from "react";
import { useSWRFetcher } from "./useSWRFetcher";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { ToastContext } from "../context/ToastContext";
import { environment } from "../config/environment";

export const useInvoiceDispute = (enabled?: boolean) => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { data: disputeReasonCodes } = useSWR<
    {
      id: string;
      description: string;
    }[]
  >(enabled ? `${environment.apiUrl}/api/invoices/disputes/reasons` : null, (url: string) => fetcher(url), {
    onError: () => {
      showToast("Failed to get invoice dispute reasons, please try again later", "error");
    },
  });

  const { trigger: submitInvoiceDispute, isMutating: isInvoiceDisputeSubmitting } = useSWRMutation(
    `${environment.apiUrl}/api/invoices/disputes`,
    (
      url: string,
      {
        arg,
      }: {
        arg: {
          reason: string;
          reasonCode?: string;
          invoiceId: string;
        };
      }
    ) =>
      fetcher(url, {
        method: "POST",
        body: JSON.stringify(arg),
      }),
    {
      onError: () => {
        showToast("Failed to submit invoice dispute, please try again later", "error");
      },
    }
  );

  return {
    disputeReasonCodes: disputeReasonCodes || [],
    isInvoiceDisputeSubmitting,
    submitInvoiceDispute,
  };
};
